import moment from 'moment';

import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// actions

const GET_SHIPPING_GROUPS = 'luft/shipping-group/GET_SHIPPING_GROUPS';
const GET_SHIPPING_GROUPS_SUCCESS =
  'luft/shipping-group/GET_SHIPPING_GROUPS_SUCCESS';
const GET_SHIPPING_GROUPS_FAILURE =
  'luft/shipping-group/GET_SHIPPING_GROUPS_FAILURE';

// reducer

const initialState = {
  isFetching: false,
  error: '',
  requested: '',
  list: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_SHIPPING_GROUPS:
      return {
        ...state,
        isFetching: true,
        error: '',
        requested: moment().format('YYYY-MM-DD HH:mm:ss'),
      };

    case GET_SHIPPING_GROUPS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: '',
        list: action.list,
      };

    case GET_SHIPPING_GROUPS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators

function _getShippingGroups() {
  return { type: GET_SHIPPING_GROUPS };
}

function _getShippingGroupsSuccess(list) {
  return {
    type: GET_SHIPPING_GROUPS_SUCCESS,
    list,
  };
}

function _getShippingGroupsFailure(error) {
  return {
    type: GET_SHIPPING_GROUPS_FAILURE,
    error,
  };
}

// thunk action creators

export function getShippingGroups() {
  return function (dispatch) {
    (async () => {
      dispatch(_getShippingGroups());

      try {
        const response = await luftGet('/Shipping/GetShippingGroups');
        dispatch(_getShippingGroupsSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getShippingGroupsFailure(error.message),
        );
      }
    })();
  };
}
